import InstrumentIcon from './InstrumentIcon';

export default InstrumentIcon;
